import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { ActionIcon, Anchor, Button, Menu } from '@mantine/core'
import { randomArrayItem } from '@utils/randomArrayItem'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleUser from '@assets/exampleUser.png'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { randomBool } from '@utils/randomBool'
import { DataGridList } from '@components/DataGrid/DataGridList'
import { IconChevronDown, IconDots } from '@tabler/icons-react'

const MOCK_DATA = Array(30)
  .fill(0)
  .map((_, i) => {
    return {
      id: `staff-list-${i}`,
      status: randomArrayItem(['Active', 'Inactive']),
      phone: (
        <Anchor href="tel:+1 (212) 555-1212" c="dark">
          +1 (212) 555-1212
        </Anchor>
      ),
      email: (
        <Anchor href="mailto:info@example.com" c="dark">
          info@example.com
        </Anchor>
      ),
      locations: randomBool() ? (
        'All'
      ) : (
        <DataGridList
          title="Locations"
          data={['Some', 'Another', 'And another']}
        />
      ),
      permissions: randomArrayItem(['Admin', 'Read-only', 'Custom']),
      twoStep: randomArrayItem(['Enrolled', 'Not enrolled']),
      lastLogin: randomArrayItem(['Today', '6w 3d', '2mo 21d']),
    }
  })

export const Staff = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Staff'))
  })

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Status',
      prop: 'status',
    },
    {
      label: 'Email',
      prop: 'email',
    },
    {
      label: 'Phone',
      prop: 'phone',
    },
    {
      label: 'Locations',
      prop: 'locations',
    },
    {
      label: 'Tags',
      prop: 'tags',
    },
    {
      label: 'Permissions',
      prop: 'permissions',
    },
    {
      label: '2-step verification',
      prop: 'twoStep',
    },
    {
      label: 'Last login',
      prop: 'lastLogin',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Staff',
      href: '#',
      default: true,
    },
    {
      label: 'Active Staff',
      href: '#',
    },
    {
      label: 'Inactive Staff',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit permissions',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Edit location data access',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Add tags',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Activate',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Remove tags',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Deactivate',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Tags',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
      component: (
        <div>
          <Menu position="bottom-start">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Tags
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Edit permissions</Menu.Item>
              <Menu.Item>Edit location data access</Menu.Item>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item>Reactivate</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
              <Menu.Item color="red">Deactivate</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  const data = MOCK_DATA.map((curr, i) => {
    return {
      ...curr,
      name: (
        <DataGridPerson
          name="Alfredo Carrillo"
          status="online"
          image={ExampleUser}
          onClick={handleNavigate}
        />
      ),
    }
  })

  return (
    <DataGrid
      data={data}
      columns={columns}
      sections={sections}
      actions={actions}
      results={data.length}
      buttons={<Button>Invite staff</Button>}
      selectedActions={selectedActions}
      page={1}
    />
  )
}
